import PropTypes from 'prop-types';
import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Box, Drawer, useMediaQuery } from '@mui/material';

// project import
import DrawerHeader from './DrawerHeader';
import DrawerContent from './DrawerContent';
import MiniDrawerStyled from './MiniDrawerStyled';
import { DRAWER_WIDTH } from 'config';
import { openDrawer } from 'store/features/menu/menuSlice';

// ==============================|| MAIN LAYOUT - DRAWER ||============================== //

const MainDrawer = ({ window }) => {
	const theme = useTheme();
	const dispatch = useDispatch();
	const matchDownMD = useMediaQuery(theme.breakpoints.down('lg'));
	const open = useSelector((state) => state.menu.drawerOpen);

	// responsive drawer container
	const container = window !== undefined ? () => window().document.body : undefined;

	// header content
	const drawerContent = useMemo(
		() => <DrawerContent style={!matchDownMD && { borderRight: `1px solid ${theme.palette.border}` }} />,
		[matchDownMD, theme.palette.border]
	);

	const drawerHeader = useMemo(() => <DrawerHeader open={open} />, [open]);

	return (
		<Box component="nav" sx={{ flexShrink: { md: 0 }, zIndex: 1000 }} aria-label="lyn sidebar">
			{!matchDownMD ? (
				<MiniDrawerStyled variant="permanent" open={open}>
					{drawerHeader}
					{drawerContent}
				</MiniDrawerStyled>
			) : open ? (
				<Drawer
					container={container}
					variant="temporary"
					open={open}
					onClose={() => dispatch(openDrawer({ drawerOpen: false }))}
					ModalProps={{ keepMounted: true }}
					sx={{
						display: { xs: 'block', lg: 'none' },
						'& .MuiDrawer-paper': {
							boxSizing: 'border-box',
							width: DRAWER_WIDTH,
							// top: '8px',
							// borderRight: `1px solid ${theme.palette.border}`,
							backgroundImage: 'none',
							boxShadow: 'inherit',
							backgroundColor: 'background.drawer',
						},
					}}
				>
					{open && drawerHeader}
					{open && drawerContent}
				</Drawer>
			) : null}
		</Box>
	);
};

MainDrawer.propTypes = {
	open: PropTypes.bool,
	window: PropTypes.object,
};

export default MainDrawer;
